module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"sub_title":"장바구니 상품 목록"}}')
  delete Component.options._Ctor
}
